/**
 * Zwei Arten von Seitentiteln.
 *
 * App-Seiten setzen kurze Abschnittsnamen (`<Head title="Kontakte" />`) und
 * erwarten, dass die Marke angehängt wird. Die öffentlichen Seiten liefern über
 * `SEOHead` dagegen einen vollständigen, so indexierten SEO-Titel – dort wäre
 * ein angehängtes " - Fahrdienst Software" eine Änderung am Title-Tag.
 *
 * Inertias Head-Manager kennt diesen Unterschied nicht: er schickt *jeden*
 * Titel durch den `title`-Callback aus `entrypoints/inertia.tsx`, egal ob er
 * als Prop oder als `<title>`-Kind kam. Deshalb markiert `SEOHead` seine Titel,
 * und der Callback nimmt die Markierung wieder ab.
 *
 * Die Markierung ist ein Zero-Width Space: Sollte sie je durchrutschen, ist sie
 * im Browser-Tab unsichtbar statt als Zeichensalat zu erscheinen.
 */

const EXACT_TITLE_MARKER = "​"

/** Markiert einen Titel als vollständig – er wird unverändert übernommen. */
export function exactTitle(title: string) {
  return `${EXACT_TITLE_MARKER}${title}`
}

/**
 * Gibt den Titel ohne Markierung zurück, oder `null`, wenn er nicht markiert
 * war und die Marke noch angehängt werden soll.
 */
export function readExactTitle(title: string) {
  return title.startsWith(EXACT_TITLE_MARKER)
    ? title.slice(EXACT_TITLE_MARKER.length)
    : null
}
